module.exports = __webpack_public_path__ + "67a900c70f65131f4bf187a738912fc0.MP3";